import React from "react";

export function Button(props) {
	return (
		<button
			className={`btn ${!props.adequateLength && "min-length-message"} ${
				props.adequateLength && !props.passwordsMatch ? "passwords-match-message" : ""
				} ${props.buttonType ? props.buttonType : ""}`}
			type="button"
			aria-label={props.text}
			onClick={props.onClick ? props.onClick : ""}
			disabled={props.disabled}
		>
			{props.children ? props.children : props.text}
		</button>
	);
};

export function FormInputButton(props) {
	return (
	<input 
		className={props.inputClassNames}
		type="submit"
		value={props.label}
		aria-label={props.label} 
		disabled={props.disabled}
		data-testid={props.dataTestId}/>
)};